import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Refused, ZeroFreq, Assess, Discontinued, BiWeekly, BiMonthly, Daily } from '@mummssoftware/utils/frequencies/frequency-constants';
import { formatDateMMDDYY } from '@mummssoftware/utils/formatters';
import { PRN } from '@mummssoftware/utils/orders/orders-constants';

const formatOrderStatement = carePlanFrequencies => Object.values(carePlanFrequencies).filter(value => value === null || value === void 0 ? void 0 : value.name).map(carePlanFrequency => {
  const {
    effectiveDate,
    period,
    name,
    frequency,
    prn
  } = carePlanFrequency;
  const effectiveDateValue = effectiveDate && formatDateMMDDYY(effectiveDate);
  const hideFrequency = period === Refused || period === ZeroFreq || period === Discontinued || period === Assess || period === BiWeekly || period === BiMonthly || period === Daily;
  const effectiveMessage = ` This will take effect ${effectiveDateValue}.`;
  let message = '';
  let andPRN = '';

  if (carePlanFrequency.orderType === PRN) {
    if (prn) {
      message = `${name} to provide services on an as-needed basis (PRN).`;
    } else {
      message = `${name}: Discontinue PRN visits.`;
    } // CPF

  } else {
    if (period === Refused || period === ZeroFreq) {
      message = `${name} not to visit the patient`;
    } else if (period === Assess) {
      message = `${name} to visit the patient 1 time to assess`;
    } else if (period === Discontinued) {
      message = `${name} visits to be discontinued`;
    } else {
      message = `${name} to visit the patient${frequency && !hideFrequency && ` ${frequency} time${frequency !== 1 && 's' || ''}` || ''} ${period && (period === null || period === void 0 ? void 0 : period.toLowerCase()) || ''}`;
    }

    andPRN = prn ? ' and PRN.' : '.';
  }

  carePlanFrequency.frequencyMessage = `${message}${andPRN}${effectiveMessage}\n`;
  return '';
});

export const updateVForderData = (editingDTO, updates) => {
  const {
    entryId
  } = updates;
  const key = entryId != null ? String(entryId) : String(updates === null || updates === void 0 ? void 0 : updates.id);

  if (editingDTO[key]) {
    editingDTO[key] = _objectSpread(_objectSpread(_objectSpread({}, editingDTO[key]), updates), {}, {
      entryId: entryId || editingDTO[key].entryId
    });
  } else {
    editingDTO[key] = _objectSpread(_objectSpread({}, updates), {}, {
      entryId: entryId || key
    });
  }

  formatOrderStatement(editingDTO);
  return JSON.parse(JSON.stringify(editingDTO));
};